<style>
#profileModal .v--modal-box.v--modal {
  min-height: 450px !important;
  min-width: 540px !important;
}
#profileModal .first-subheader {
  margin-top: 5px;
}
#btn--add-hydrant,
#btn--area {
  margin-left: 0 !important;
  background-color: #2a579a;
}
#profileModal p {
  margin-top: auto;
  margin-bottom: auto;
  text-align: left;
}
#profileModal li > span {
  text-align: right;
}
#profileModal .li {
  text-align: center;
}
#profileModal .select__wrapper {
  border-bottom: 1px solid lightgrey;
}
#profileModal .values__list {
  display: flex;
}
.card__print--icon {
  opacity: 0.4;
  line-height: 40px;
  transition: all 0.2s;
}
.card__print--icon:hover {
  opacity: 1;
}
.card__print--wrapper {
  text-align: right;
}
#profileModal * {
  font-size: 12px;
}
#profileModal .img__wrapper {
  height: calc(100% - 70px);
  width: 100%;
}
#profileModal .title--main {
  height: 25px !important;
  font-size: 20px !important;
  justify-content: center;
}
#profileModal .title--subtitle {
  height: 20px !important;
  margin-bottom: 25px;
  font-size: 15px !important;
  justify-content: center;
}
#profileModal .v-image {
  height: calc(100% - 70px);
  width: 100%;
}
</style>

<template>
  <Modal
    modalName="profileModal"
    title="Profil"
    :buttons="['']"
    @opened="getProfile()"
    @closed="closed()"
    v-if="profile"
  >
    <div class="title__wrapper">
      <v-subheader class="title--main">Profil podłużny sieci kanalizacyjnej</v-subheader>
      <v-subheader class="title--subtitle">Odcinek {{videoInspectionData.start_manhole_id}}-{{videoInspectionData.end_manhole_id}}</v-subheader>
    </div>
    <div class="img__wrapper">
      <v-img
        :src="url"
        alt="Trwa pobieranie profilu"
      >
      </v-img>
    </div>
  </Modal>
</template>

<script>
import Modal from '../../../shared/Modal';

export default {
  components: {
    Modal
  },
  data: () => ({
    profile: [],
  }),
  computed: {
    videoInspectionData() {
      return this.$store.getters.getVideoInspectionCard;
    },
    url() {
      return `${this.$store.getters.getApiURL}/video/profile/${this.videoInspectionData.id}?token=${this.$store.getters.getToken}`
    }
  },
  methods: {
    getProfile() {

    },
    closed() {

    }
  },
  mounted() {

  }
}
</script>



// WEBPACK FOOTER //
// src/components/viewer/video/modals/Profile.vue